module.exports = __webpack_public_path__ + "static/media/Screenshot3.d3e94aab.png";